import React from 'react';

/**
 * Single page background layer using pre-rendered server-side image.
 * Renders behind ads with configurable opacity and grayscale.
 */
export const PdfPageBackground = React.memo(({ imageSrc, opacity, grayscale }) => {
  if (!imageSrc) return null;

  return (
    <div
      className="absolute inset-0 z-[1] pointer-events-none"
      data-testid="pdf-overlay-bg"
      style={{
        opacity: opacity / 100,
        filter: grayscale ? 'grayscale(100%)' : 'none',
      }}
    >
      <img
        src={imageSrc}
        alt=""
        className="w-full h-full object-cover"
        draggable={false}
      />
    </div>
  );
});
